import { axios } from '@/utils/request'

// 获取TDK
export function getSeoOptimization(params) {
  return axios({
    url: '/api/seo/getDetails',
    method: 'GET',
    params
  })
}
